import { useMemo } from 'react';
import { AvatarFallbackColor } from '@cbhq/cds-common';
import { Box } from '@cbhq/cds-web/layout';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { Avatar } from '@cbhq/cds-web/media/Avatar';

import { useProfileMenuV2 } from '../../providers/ProfileMenuV2Provider';

export function fallbackColor(index: number): AvatarFallbackColor {
  switch (index) {
    case 0:
      return 'purple';
    case 1:
      return 'pink';
    case 2:
      return 'teal';
    case 3:
      return 'green';
    default:
      return 'blue';
  }
}

export function AvatarStack() {
  const { otherProfiles } = useProfileMenuV2();

  // This component need to render the avatars stack for all avatars except selected profile avatar, the index 0
  const avatars = useMemo(
    () =>
      otherProfiles.map((profile) => ({
        url: profile.avatarUrl,
        name: profile.name,
      })),
    [otherProfiles],
  );

  if (avatars.length === 0) return null;

  return (
    <HStack alignItems="center" testID="avatar-stack-container">
      {avatars.map(({ url, name }, index) => (
        <Box key={(url ?? '') + name} marginStart={-1}>
          <Avatar src={url} name={name} alt="" size="m" colorScheme={fallbackColor(index)} />
        </Box>
      ))}
    </HStack>
  );
}
